// extracted by mini-css-extract-plugin
export var shake = "_19-0";